export default __webpack_public_path__ + "static/media/Leggings of the Spheres.e26d4c60.jpg";